import React, { useState } from "react";
import { toast } from "sonner";
import { Download, FileWarning, Trash2 } from "lucide-react";
import { api, API_BASE, getToken } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// Hak subjek data (UU PDP No. 27/2022): salinan data & penghapusan akun langsung dari aplikasi.
export function DataPrivacyCard() {
  const { logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const exportData = async () => {
    setBusy(true);
    try {
      const res = await fetch(`${API_BASE}/auth/me/export`, { headers: { Authorization: `Bearer ${getToken()}` } });
      if (!res.ok) throw new Error("export failed");
      const blob = await res.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob); a.download = "oryntix-data-saya.json"; a.click();
      URL.revokeObjectURL(a.href);
      toast.success("Salinan data Anda sedang diunduh");
    } catch { toast.error("Gagal menyiapkan salinan data"); } finally { setBusy(false); }
  };

  const deleteAccount = async () => {
    setBusy(true);
    try {
      await api.post("/auth/delete-account", { password: pw, confirm });
      toast.success("Akun dan data Anda telah dihapus");
      await logout();
    } catch (e) { toast.error(e?.response?.data?.detail || "Gagal menghapus akun"); } finally { setBusy(false); }
  };

  return (
    <div className="mt-4 aivora-card p-6" data-testid="data-privacy-card">
      <p className="flex items-center gap-2 font-semibold text-slate-900"><FileWarning size={16} className="text-[#2F6BFF]" /> Data & Privasi</p>
      <p className="mt-1 text-xs text-slate-500">Sesuai UU No. 27/2022 (PDP) Anda berhak memperoleh salinan data pribadi dan menghapusnya. Lengkapi dari menu ini atau hubungi privacy@oryntix.com. Rincian di <a href="/privacy" target="_blank" rel="noreferrer" className="font-semibold text-[#2F6BFF] hover:underline">Kebijakan Privasi</a>.</p>
      <div className="mt-4 flex flex-wrap gap-2">
        <button onClick={exportData} disabled={busy} className="flex items-center gap-2 rounded-xl border border-[#E7ECF3] px-4 py-2.5 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 disabled:opacity-50" data-testid="export-data-btn"><Download size={15} /> Unduh salinan data saya (JSON)</button>
        <button onClick={() => setOpen((v) => !v)} className="flex items-center gap-2 rounded-xl border border-[#EF4444]/30 bg-[#EF4444]/5 px-4 py-2.5 text-sm font-semibold text-[#EF4444] transition hover:bg-[#EF4444]/10" data-testid="delete-account-toggle"><Trash2 size={15} /> Hapus akun saya</button>
      </div>
      {open && (
        <div className="mt-4 rounded-xl border border-[#EF4444]/30 bg-[#FFF5F5] p-4" data-testid="delete-account-form">
          <p className="text-xs text-slate-700">Semua percakapan, dokumen, asisten, memori, pengingat, dan berkas Anda akan dimusnahkan dan sesi di semua perangkat dicabut. Catatan transaksi disimpan tanpa identitas sesuai kewajiban hukum. Tindakan ini tidak dapat dibatalkan.</p>
          <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Kata sandi Anda" className="input-dark mt-3 w-full" data-testid="delete-account-password" />
          <input value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder='Ketik HAPUS untuk mengonfirmasi' className="input-dark mt-2 w-full" data-testid="delete-account-confirm" />
          <button onClick={deleteAccount} disabled={busy || !pw || confirm.trim().toUpperCase() !== "HAPUS"} className="mt-3 rounded-xl bg-[#EF4444] px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-[#DC2626] disabled:opacity-50" data-testid="delete-account-btn">{busy ? "Menghapus…" : "Hapus akun secara permanen"}</button>
        </div>
      )}
    </div>
  );
}
